import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

import { authProvider } from "authProvider";

export default {
  title: "Listini",
  resource: "listino-bookings",
  canCreate: true,
  customDataGetter: async () => {
    let user = await authProvider.getUserIdentity();
    return user.id;
  },
  dataGridParams: (cData) => {
    //cData in this case will contain user ID
    return {
      permanentFilter: [
        {
          field: "struttura.owner.id",
          operator: "eq",
          value: cData,
        },
      ],
    };
  },
  columns: [
    { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
    {
      field: "discount",
      headerName: "Sconto",
      valueGetter: ({ row }) => {
        const value = row?.discount;
        return `${value} %`;
      },
      flex: 1,
      minWidth: 300,
    },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 150,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <EditButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
